import { DO_INIT_MENU, DO_ACTIVE_PAGE, DO_ACTIVE_SUB_PAGE, DO_CHANGE_SIMPLE_MODE, DO_CHANGE_DETAIL_MODE } from '../actions/menu/index';

const doMenu = (state, action) => {
  switch (action.type) {    
    case DO_INIT_MENU:
      return {
        status: DO_INIT_MENU,
        activePage: null,
        activeSubPage: null,
        displayMode: 'simple-mode'
      }
    case DO_ACTIVE_PAGE:
      return {       
        ...state,
        status: DO_ACTIVE_PAGE,
        activePage: action.params.activePage,
        activeSubPage: null,
        data: action.params.data
      }
    case DO_ACTIVE_SUB_PAGE:
      return {
        ...state,
        status: DO_ACTIVE_SUB_PAGE,
        activeSubPage: action.params.activeSubPage
      }
    case DO_CHANGE_SIMPLE_MODE:
      return {
        ...state,
        status: DO_CHANGE_SIMPLE_MODE,
        displayMode: 'simple-mode'
      }
    case DO_CHANGE_DETAIL_MODE:
      return {
        ...state,
        status: DO_CHANGE_DETAIL_MODE,
        displayMode: 'detail-mode'
      }
    default:
      return state;
    }
}

const menuReducers = (state = {
  activePage: null,
  activeSubPage: null,
  displayMode: 'simple-mode',
  status: 'WAIT_INIT_MENU',
  data: null,
  subMenu: {
    dashboard: [{
      id: 'dashboard',
      name: 'Dashboard',
      url: null
    }],
    analyzer: [
      {
        id: 'threatstatistics',
        name: 'Threat Statistics',
        url: '/threat-statistics'
      }, {
        id: 'ipsattackmap',
        name: 'IPS Attack Map',
        url: '/ips-attack'
      }, {
        id: 'deviceranking',
        name: 'Device Ranking',
        url: '/device-ranking'
      }
    ],
    report: [{
      id: 'report',
      name: 'Summary Report',
      url: null
    }],
    alert: [{
      id: 'alert',
      name: 'Alert List',
      url: null
    }],
    device: [{
      id: 'device',
      name: 'Device Status',
      url: null
    }]
  }
}, action) => {
  switch (action.type) {
    default:
      return doMenu(state, action);
  }
}

export default menuReducers;